// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { createSlice } from '@reduxjs/toolkit'

let BaseURL = process.env.REACT_APP_BASEURL

// Define a service using a base URL and expected endpoints
export const adminApi = createApi({
  reducerPath: 'adminApi',
  baseQuery: fetchBaseQuery({ baseUrl: BaseURL }),
  endpoints: (builder) => ({
    searchForCode: builder.query({
      query: (code) => `public/code/search/${code}`,
    }),
    signIn: builder.query({
        query: (value) => `public/code/signIn/${value.code}/${value.email}`,
      }),
    adminCustomer: builder.query({
      query: (value) => `public/code/signIn/${value.code}/${value.email}`,
      }),
  }),
})



export const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    code: "",
    customerId: "",
    email: "",
    link: ""
  },
  reducers: {
    setCustomer: (state,action) => { 
        state.code = action.payload.code
        state.customerId = action.payload.customerId
        state.email = action.payload.email
        state.link = action.payload.link
    }
  },
})

export const { setCustomer } = adminSlice.actions

export const adminReducer =  adminSlice.reducer

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLazySearchForCodeQuery, useLazySignInQuery, useLazyAdminCustomerQuery } = adminApi